import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import portfoliobag from "../../assets/images/svg/portfoliobag.svg";
import Modal from "../Modal";
import ModalFamily from "../ModalFamily/ModalFamily";
import PagesTabs from "../PagesTab/PagesTabs";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import AuthStore from "../../store/AuthStore";
import PerformanceStore from "../../store/PerformanceStore";
import PerformanceTabsContent from "../PerformanceTabsContent/PerformanceTabsContent";
import UserStore from "../../store/UserStore";
import {
  getDuraion,
  logEvents,
  trackEventWithScreen,
} from "../../utils/functions";
import { PERFORMANCE_PAGE } from "../../utils/constants";
import PageHeading from "../PageHeading/PageHeading";

const PerformanceSub = () => {
  const [loaderProp, setLoaderProp] = useState(false);
  const [selectedMember, setSelectedMember] = useState("0");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openFamilyModal, setOpenFamilyModal] = useState(false);
  const { performanceRoute2, performanceRoute3 } = useParams();
  const handleTab = ({ data, index }) => {
    if (data?.id === 6) PerformanceStore.setFirstPageTableEmpty();
    PerformanceStore.setData("isAssetClassClicked", true);
    trackEventWithScreen({
      eventName: PERFORMANCE_PAGE,
      screenName: data?.name,
    });
    logEvents(PERFORMANCE_PAGE, {
      screenName: data?.name,
    });
    setLoaderProp(true);

    const localId = PerformanceStore.selectedAssetClass?.id;
    PerformanceStore.setDerivativeRef("");
    PerformanceStore.setFirstPageRef("");
    PerformanceStore.setLoaderClosingCheck({});

    PerformanceStore.setAssetClass(
      data,
      getDuraion(PerformanceStore.selectedDuration, data?.id),
      // data.id !== 6 ? PerformanceStore.selectedDuration : undefined
    );

    if (localId !== data?.id) {
      PerformanceStore.setCurrentLoader("mainTabLoader");
      PerformanceStore.setPerformanceLoader("mainTabLoader", true);
    }
    setSelectedIndex(index);
  };

  useEffect(() => {
    // For accessibility purpose selected asset class index should be in sync with the selected index state
    const index = PerformanceStore.assetClasses?.findIndex(
      (data) => data.id === PerformanceStore.selectedAssetClass?.id,
    );
    setSelectedIndex(index !== -1 ? index : 0);
    return () => {
      // PerformanceStore.setAssetClassOnly();
    };
  }, [PerformanceStore.selectedAssetClass]);

  return (
    <>
      {AuthStore.isLoadingFullScreen ||
      !PerformanceStore.isHydrated ||
      !UserStore.isHydrated ? (
        <LoadingScreen />
      ) : (
        <>
          <div
            className={
              performanceRoute3 === undefined
                ? "performance_outer_main perform_outside"
                : "performance_outer_main"
            }
          >
            {performanceRoute2 === undefined && (
              <>
                <div className="heading1">
                  <div className="title_container">
                    <img src={portfoliobag} alt="" />{" "}
                    <PageHeading
                      headingClass="pages_title "
                      headingText="Your Portfolio Performance"
                    />
                  </div>
                </div>
                <div>
                  <PagesTabs
                    tabsDataProp={PerformanceStore.assetClasses}
                    selectedTab={PerformanceStore.selectedAssetClass}
                    handleTab={({ tab, index }) =>
                      handleTab({ data: tab, index })
                    }
                    setOpenFamilyModal={(data) => setOpenFamilyModal(data)}
                    selectedMember={selectedMember}
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex}
                  />
                </div>
              </>
            )}
            <div
              id={`panel-${selectedIndex}`}
              role="tabpanel"
              aria-labelledby={
                PerformanceStore.assetClasses?.[selectedIndex]?.id
              }
              className="tabs_content"
            >
              <PerformanceTabsContent
                selectedTab={""}
                setLoaderProp={setLoaderProp}
                loaderProp={loaderProp}
              />
            </div>
          </div>
          <Modal
            onClose={() => setOpenFamilyModal(false)}
            open={openFamilyModal}
            title={"Select Family Member"}
            width={"810px"}
          >
            <ModalFamily
              setSelectedMember={(id) => setSelectedMember(id)}
              selectedMember={selectedMember}
              onClose={() => setOpenFamilyModal(false)}
            />
          </Modal>
        </>
      )}
    </>
  );
};

export default observer(PerformanceSub);
